import { CloudGatewayDiscoveredDevice } from '@shure/cloud/shared/models/devices';
import { mapDeviceModelFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';

import { CloudGatewayDiscoveredDeviceFragment } from '../graphql/generated/cloud-sys-api';

export function mapCloudGatewayDiscoveredDeviceFromSysApi(
	device: CloudGatewayDiscoveredDeviceFragment
): CloudGatewayDiscoveredDevice {
	return {
		hardwareId: device.hardwareId,
		name: device.name,
		model: mapDeviceModelFromSysApi(device.model),
		macAddress: device.macAddress ?? undefined,
		serialNumber: device.serialNumber,
		ipAddress: device.ipAddress ?? undefined,
		roomName: device.roomName ?? undefined,
		firmwareSupported: device.firmwareSupported,
		manageable: device.manageable,
		managingCloudGateway: device.managingGateway
			? {
					id: device.managingGateway.id,
					name: device.managingGateway.features.name?.name ?? '--',
					model: mapDeviceModelFromSysApi(device.managingGateway.interface.model)
			  }
			: undefined
	};
}
